import { ExampleElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Example extends ExampleElement {
  /**
   * OpenAPI 3.2: Structured example data as an ApiDOM Element.
   */
  get dataValue() {
    return this.get('dataValue');
  }
  set dataValue(dataValue) {
    this.set('dataValue', dataValue);
  }

  /**
   * OpenAPI 3.2: Serialized example value as a string.
   */
  get serializedValue() {
    return this.get('serializedValue');
  }
  set serializedValue(serializedValue) {
    this.set('serializedValue', serializedValue);
  }
}
export default Example;